/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);



//////////////////
// WEBPACK FOOTER
// ./~/react-router/es6/hashHistory.js
// module id = 1355
// module chunks = 60